var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sui-image", {
    staticClass: "igc-item-banner",
    attrs: {
      src:
        "//tiem-cdn.qq.com/sy/" +
        _vm.$store.state.global.game +
        "/ingame/images/banner.png"
    },
    nativeOn: {
      click: function($event) {
        return _vm.to($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }